import { render, staticRenderFns } from "./InsuranceSkladUsaShow.vue?vue&type=template&id=08ed02c9&scoped=true"
import script from "./InsuranceSkladUsaShow.vue?vue&type=script&lang=js"
export * from "./InsuranceSkladUsaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed02c9",
  null
  
)

export default component.exports